/**
 *
 * Asynchronously loads the component for RunPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const RunDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.RunDetailsPage,
);
